import { Reveal, Eyebrow } from "@/lib/motion";

const ROWS = [
  {
    name: "ServiceTitan Workflows",
    body: "Built for field-service work orders, not cross-team ops — heavier setup, narrower fit outside trades.",
  },
  {
    name: "UiPath",
    body: "Enterprise RPA horsepower built for IT-run automation projects, not something an ops manager configures in an afternoon.",
  },
  {
    name: "Zapier for Teams",
    body: "Connects your tools, but doesn’t enforce SOPs, track SLAs, or route by workload. Plumbing, not ops management.",
  },
  {
    name: "Notion Automations",
    body: "Fine for internal docs and light task tracking, not built for SLA enforcement or audit trails.",
  },
  {
    name: "Asana",
    body: "A project management tool stretched to cover ops workflows it wasn’t designed for. No SLA routing, no compliance tracking.",
  },
];

export default function WhyNot() {
  return (
    <section id="why-not" className="relative bg-bg-primary/55 py-24 backdrop-blur-sm lg:py-32">
      <div className="container-max band-pad">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow testId="whynot-eyebrow">Why not…</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              You’ve probably tried a few of these.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 flex flex-col">
          {ROWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.05}>
              <div
                data-testid={`whynot-${i}`}
                className="group grid grid-cols-1 gap-3 border-t border-hairline py-7 transition-colors hover:bg-white/[0.015] md:grid-cols-[minmax(0,320px)_1fr] md:gap-10"
              >
                <div className="flex items-center gap-3">
                  <span className="font-mono text-lg text-ink-muted transition-colors group-hover:text-warning">
                    ×
                  </span>
                  <span className="font-display text-xl font-semibold text-ink">
                    {r.name}
                  </span>
                </div>
                <p className="leading-relaxed text-ink-muted">{r.body}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-hairline" />
        </div>
      </div>
    </section>
  );
}
